
















































































import { Component, Vue } from 'vue-property-decorator';
import CollectionOption from '@/components/collections/CollectionOption.vue';
import CollectionTitle from '@/components/collections/CollectionTitle.vue';
import CollectionItemContainer from '@/components/collection-items/CollectionItemContainer.vue';
import CollectionItemStore, {
  CollectionItemStoreInterface,
} from '@/resource/collection-item/collection-item.store';
import { Collection } from '@/resource/collection/collection.model';
import { CollectionItem } from '@/resource/collection-item/collection-item.model';
import QuestionLoading from '@/components/questions/QuestionLoading.vue';
import CollectionItemLoading from '@/components/collection-items/CollectionItemLoading.vue';
import CollectionItemEmpty from '@/components/collection-items/CollectionItemEmpty.vue';
import NotFound from '@/components/common/NotFound.vue';
import CollectionRearrange from '@/components/collections/CollectionRearrange.vue';
import ModalGeneratePdf from '@/components/modals/ModalGeneratePdf.vue';
import { MetaInfo } from 'vue-meta/types/vue-meta';
import seoDefault from '@/utils/seo-default';

@Component({
  components: {
    CollectionItemContainer,
    CollectionOption,
    CollectionTitle,
    QuestionLoading,
    CollectionItemLoading,
    CollectionItemEmpty,
    CollectionRearrange,
    NotFound,
    ModalGeneratePdf,
  },
  metaInfo(this: CollectionPage): MetaInfo {
    return {
      title: 'Collection |',
      meta: [
        ...seoDefault({
          title: 'Collection | Mysoalan',
          description:
            'A collection is a place where you can collect any question from the question bank. You can mix any question you want in it, from the easiest question to the hardest question.',
        }),
      ],
    };
  },
})
export default class CollectionPage extends Vue {
  collectionItemStore: CollectionItemStoreInterface = CollectionItemStore;
  collection: Collection | null = null;

  isLoading = true;
  isLoadingAddQuestions = false;
  showRearrangePositions = false;
  showGeneratePdf = false;

  // NOTE: to keep track if there is changes on question position
  // if false, whenever user click done, client will not send req to backend
  isQuestionPositionChanged = false;

  get collectionUuid() {
    return this.$route.params.uuid;
  }

  get collectionItems(): CollectionItem[] {
    return this.collectionItemStore.collectionItems;
  }
  get lastObjectiveQuestion() {
    return this.collectionItemStore.lastObjectiveQuestion;
  }

  get totalQuestions(): number {
    return this.collectionItemStore.pagination.totalRecords;
  }

  get totalFetchQuestions(): number {
    return this.collectionItemStore.collectionItems.length;
  }

  get totalSubjectiveQuestions(): number {
    return this.collectionItemStore.totalSubjectiveQuestions;
  }

  get collectionFound() {
    if (this.isLoading) {
      return true;
    } else if (!this.isLoading && this.collection) {
      return true;
    } else {
      return false;
    }
  }

  get disableCollectionOption() {
    if (
      this.isLoading ||
      this.isLoadingAddQuestions ||
      !this.collectionItems.length ||
      this.showRearrangePositions
    ) {
      return true;
    } else {
      return false;
    }
  }

  get disableAddOwnQuestion() {
    if (
      this.isLoading ||
      this.isLoadingAddQuestions ||
      this.showRearrangePositions
    ) {
      return true;
    } else {
      return false;
    }
  }

  async created() {
    if (this.collectionUuid) {
      await this.collectionItemStore.fetchCollection(this.collectionUuid);
      this.collection = this.collectionItemStore.collection;
      await this.fetchQuestions();
      window.addEventListener('scroll', this.scrollBottom);
    }
  }

  beforeDestroy() {
    // NOTE: Unmount sroll bottom to fetch data
    window.removeEventListener('scroll', this.scrollBottom);
  }

  async fetchQuestions() {
    this.isLoading = true;
    if (this.collection) {
      this.collectionItemStore.pagination.isResetPage = true;
      this.collectionItemStore.pagination.page = 1;
      await this.collectionItemStore.fetchCollectionItems(this.collectionUuid);
    }
    this.isLoading = false;
  }

  async updateCollectionName(collection: Collection) {
    await this.collectionItemStore.updateCollectionName(collection);
  }

  moveCollectionItem(fromIndex: number, toIndex: number) {
    const currentItem = this.collectionItems[fromIndex];
    const originalItem = this.collectionItems[toIndex];

    const currentItemPosition = currentItem.questionPosition;
    const originalItemPosition = originalItem.questionPosition;

    currentItem.questionPosition = originalItemPosition;
    originalItem.questionPosition = currentItemPosition;

    this.collectionItems.splice(fromIndex, 1);
    this.collectionItems.splice(toIndex, 0, currentItem);
    this.isQuestionPositionChanged = true;
  }

  async updateQuestionPositions() {
    if (this.isQuestionPositionChanged) {
      if (this.isLoading || this.isLoadingAddQuestions) return;

      this.isLoading = true;
      this.showRearrangePositions = false;
      await this.collectionItemStore.updateQuestionPositions();
      await this.fetchQuestions();
    } else {
      this.showRearrangePositions = false;
    }
    this.isQuestionPositionChanged = false;
  }

  openRearrangePositions() {
    this.showRearrangePositions = true;
  }

  async closeRearrangePositions() {
    this.showRearrangePositions = false;
    if (this.isQuestionPositionChanged) {
      this.isLoading = true;
      await this.fetchQuestions();
    }
    this.isQuestionPositionChanged = false;
  }

  openGeneratePdf() {
    this.showGeneratePdf = true;
  }

  closeGeneratePdf() {
    this.showGeneratePdf = false;
  }

  async createPdf() {
    if (this.isLoading || this.isLoadingAddQuestions) return;

    await this.collectionItemStore.createPdf();

    if (this.collectionItemStore.pdfFile && this.collection) {
      const blob = new Blob([this.collectionItemStore.pdfFile], {
        type: 'application/pdf',
      });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', this.collection.name);
      document.body.appendChild(link);
      link.click();
    }
  }

  async scrollBottom() {
    const { pagination } = this.collectionItemStore;

    if (
      this.isLoading ||
      this.isLoadingAddQuestions ||
      pagination.page >= pagination.totalPages
    ) {
      return;
    }

    const bottomOfWindow =
      Math.max(
        window.pageYOffset,
        document.documentElement.scrollTop,
        document.body.scrollTop,
      ) +
        window.innerHeight +
        200 >=
      document.documentElement.scrollHeight;

    if (!bottomOfWindow) {
      return;
    } else {
      this.collectionItemStore.pagination.page += 1;

      this.isLoadingAddQuestions = true;

      await this.collectionItemStore.fetchCollectionItems(this.collectionUuid);

      this.isLoadingAddQuestions = false;
    }
  }
}
